import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Card, CardContent, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import projectLogo from 'assets/images/icon-ARC.png'; //'../assets/images/icon-CAD.svg';//'../assets/images/hero-image.png';//
import ptsLogo from 'assets/images/PTS-logo.png';
import splashScreen from 'assets/images/login-splash.jpg';
import TextField2 from 'components/TextField2';
import { notify } from 'reducers/NotifierReducer';
import { resetPass, submitLoginForm } from 'reducers/UserReducer';
import { RowInner } from 'utils/formStyles';
import { passValidationErrors } from 'utils/functions';
import { Alert, AlertTitle } from '@material-ui/lab';
import { CircularProgress } from '@material-ui/core';
import { useLocation, Redirect } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  pageWrap: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: `url(${splashScreen})`,
    backgroundSize: 'cover',
  },
  card: {
    width: 450,
    maxWidth: '95%',
    background: '#fff',
    '& img': {
      width: '100%',
    },
  },
  content: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  branding: {
    width: '100%',
    height: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#0051a0', //'#ce0000',
    '& img': {
      width: 150,
      height: 'auto',
    },
  },
  branding2: {
    width: '100%',
    textAlign: 'center',
    padding: '25px 0 5px',
    '& img': {
      height: 50,
      width: 'auto',
    },
  },
  action: {
    textAlign: 'center',
    marginTop: 30,
    justifyContent: 'center',
    '& .btn': {
      background: '#0153a3',
      '&:hover': {
        background: '#0000a8',
      },
    },
    '& button': {
      paddingLeft: '4em',
      paddingRight: '4em',
      textTransform: 'uppercase',
    },
    '& button.Mui-disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
    },
  },
  version: {
    position: 'absolute',
    bottom: '0.5em',
    left: '1em',
    lineHeight: 1,
  },
  passReset: {
    fontSize: 13,
    textAlign: 'right',
    color: theme.colors.grey3,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  textField: {
    width: '100%',
  },
  invalid: {
    textAlign: 'center',
    fontSize: '1.5em',
    margin: '2em 0',
  },
  alert: {
    marginBottom: 32,
    '&.MuiAlert-standardError': {
      color: 'rgb(84, 18, 18)',
      backgroundColor: 'rgb(250, 234, 234)',
    },
  },
  formWrap: {
    marginBottom: 16,
    '& .MuiInputBase-root': {
      color: '#333',
    },
    '& .MuiFormLabel-root': {
      color: '#999',
      '&.MuiInputLabel-shrink': {
        color: theme.palette.primary.main,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    '& .MuiOutlinedInput-input:-webkit-autofill': {
      boxShadow: 'none',
      textFillColor: 'inherit',
    },
    '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.main,
    },
  },
  loader: {
    position: 'absolute',
    top: '-8px',
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.6)',
    zIndex: 10,
  },
}));

const ResetPassword = (props) => {
  const classes = useStyles();
  const { user, code } = useLocation().state || {};
  const [username, setUsername] = useState('');
  const [newPass, setNewPass] = useState('');
  const [confirmNewPass, setConfirmNewPass] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errors, setErrors] = useState([]);
  const disabled = Boolean(error || !newPass || loading || newPass !== confirmNewPass);
  const repeatPassErr = newPass === confirmNewPass ? false : "Passwords don't match";
  const [goToLogin, setGoToLogin] = useState(false);
  const [goToHome, setGoToHome] = useState(false);

  useEffect(() => {
    if (!user) {
      setGoToLogin(true);
      return;
    }
    setUsername(user);
  }, [user]);

  useEffect(() => {
    const validationErrors = passValidationErrors('', newPass);
    if (newPass && validationErrors.length) {
      setError(validationErrors[0]);
    } else {
      if (error) setError(false);
    }
    // eslint-disable-next-line
  }, [newPass]);

  const resetPassword = async () => {
    setLoading(true);
    try {
      let result = await resetPass(code, newPass, username);
      props.notify('Password updated!', 'success');
      if (result === 'TFA') {
        setGoToLogin(true);
      } else {
        await props.submitLoginForm(username, newPass);
        setGoToHome(true);
      }
    } catch (err) {
      if (err.errors && err.errors.length) {
        setErrors(err.errors);
      } else {
        const message = err.message ? err.message : 'Error resetting password';
        setErrors([message]);
      }
    }
    setLoading(false);
  };
  const redirectToLogin = async () => {
    setGoToLogin(true);
  };

  const renderForm = () => (
    <>
      <div style={{ position: 'relative' }}>
        {loading && (
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        )}
        <RowInner className={classes.formWrap}>
          <TextField2
            className={classes.textField}
            label="Username"
            value={username}
            onChange={(ev, val) => setUsername(val)}
            required
            variant="outlined"
            placeholder="Enter your username"
            type="text"
            disabled={true}
          />
        </RowInner>
        <RowInner className={classes.formWrap}>
          <TextField2
            className={classes.textField}
            label="New Password"
            value={newPass}
            onChange={(ev, val) => setNewPass(val)}
            type="password"
            error={error}
            placeholder="Enter new password*"
            disabled={loading}
          />
        </RowInner>
        <RowInner className={classes.formWrap}>
          <TextField2
            className={classes.textField}
            label="Repeat New Password"
            value={confirmNewPass}
            onChange={(ev, val) => setConfirmNewPass(val)}
            type="password"
            error={repeatPassErr}
            placeholder="Confirm password*"
            disabled={loading}
          />
        </RowInner>
        <RowInner className={`${classes.action} d-flex justify-content-between`}>
          <Button variant="outlined" autoFocus size="large" onClick={redirectToLogin}>
            Cancel
          </Button>
          <Button
            className="btn"
            color="primary"
            variant="contained"
            size="large"
            autoFocus
            onClick={resetPassword}
            disabled={disabled}>
            Continue
          </Button>
        </RowInner>
      </div>
    </>
  );

  if (goToLogin) return <Redirect to="/" />;
  else if (goToHome) return <Redirect to="/events" />;

  return (
    <div className={classes.pageWrap}>
      <Card className={classes.card}>
        <div className={classes.branding}>
          <img src={projectLogo} alt="ArchiveBrowser icon" />
        </div>
        <div className={classes.branding2}>
          <img src={ptsLogo} alt="PTS logo" />
        </div>
        <CardContent className={classes.content}>
          {errors.length > 0 && (
            <Alert severity="error" className={classes.alert}>
              <AlertTitle>Password validation errors</AlertTitle>
              <ul>
                {errors.map((err, idx) => (
                  <li key={idx}>{err}</li>
                ))}
              </ul>
            </Alert>
          )}
          {renderForm()}
        </CardContent>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => ({
  themeMode: state.theme.mode,
  websocket: state.websocket,
});

export default connect(mapStateToProps, {
  notify,
  submitLoginForm,
})(ResetPassword);
